// extracted by mini-css-extract-plugin
export default {"Container3D":"Container3D_Container3D__5TkMz","hidden":"Container3D_hidden__7gF-H"};